import { render, staticRenderFns } from "./DialogRouleteV2.vue?vue&type=template&id=52d02604&lang=pug"
import script from "./DialogRouleteV2.vue?vue&type=script&lang=js"
export * from "./DialogRouleteV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports